import React from 'react';
import { Nav, Button } from 'react-bootstrap';
import ProfileDropdown from 'components/navbar/top/ProfileDropdown';
import NotificationDropdown from 'components/navbar/top/NotificationDropdown';
// import CartNotification from 'components/navbar/top/CartNotification';
import FavoritesNavLink from './FavoritesNavLink';
import OpenOrders from './OpenOrders';
import EnrichmentGlobalIndicator from './EnrichmentGlobalIndicator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, db } from 'config/firebase';
import { resetFirestoreCache } from 'config/firestoreRecovery';

//
const TopNavRightSideNavItem = () => {

  const [user, loading] = useAuthState(auth);

  const handleResetLocalData = async () => {
    const ok = window.confirm(
      'Reset local data and reload?\n\n' +
      'This clears only this app’s local cache. You will stay logged in here and ' +
      'on other sites, and your 2FA is not affected.'
    );
    if (!ok) return;
    await resetFirestoreCache(db, { force: true });
  };

  return (
    <Nav
      navbar
      className="navbar-nav-icons ms-auto flex-row align-items-center"
      as="ul"
      key={"navBarkey"}
    >
      {user && !loading ?
        <>
            <EnrichmentGlobalIndicator />
            <NotificationDropdown />
            <OpenOrders user={user}/>
            <FavoritesNavLink user={user} />
            <Nav.Item as="li">
              <Button
                variant="link"
                size="sm"
                className="px-2 text-700"
                title="Reset local data — fixes a stuck or blank screen without logging you out"
                onClick={handleResetLocalData}
              >
                <FontAwesomeIcon icon="sync-alt" />
              </Button>
            </Nav.Item>
            <ProfileDropdown user={user}/>
        </>
      :
        <Button>Sign In</Button>
     }
    </Nav>
  );
};

export default TopNavRightSideNavItem;
